import { defineFakeRoute } from 'vite-plugin-fake-server/client';

import { auditLogs, loginLogs } from './store';
import { pageValue, resultSuccess, routeParam } from './utils';

function pageRows<T>(items: T[], page: number, pageSize: number) {
  const start = (page - 1) * pageSize;
  return {
    items: items.slice(start, start + pageSize),
    page,
    page_size: pageSize,
    total: items.length,
  };
}

function sortRows<T>(
  items: T[],
  sort: string | undefined,
  order: string | undefined,
  fields: Record<string, (item: T) => string>,
) {
  const select = sort ? fields[sort] : undefined;
  if (!select) return items;
  const direction = order === 'asc' ? 1 : -1;
  return [...items].sort(
    (left, right) => select(left).localeCompare(select(right)) * direction,
  );
}

export default defineFakeRoute([
  {
    url: '/platform/audit-logs',
    method: 'get',
    response: ({ query }) => {
      const page = pageValue(query.page, 1);
      const pageSize = pageValue(query.page_size, 10);
      const action = routeParam(query.action);
      const keyword = routeParam(query.q)?.trim().toLowerCase();
      const result = routeParam(query.result);
      const from = routeParam(query.from);
      const to = routeParam(query.to);
      const items = auditLogs.filter(
        (item) =>
          (!keyword ||
            [
              item.id,
              item.actorUsername,
              item.action,
              item.targetType,
              item.targetId,
              item.requestIp,
            ].some((value) => value?.toLowerCase().includes(keyword))) &&
          (!action || item.action.includes(action)) &&
          (!result || item.result === result) &&
          (!from || item.createdAt >= from) &&
          (!to || item.createdAt <= to),
      );
      const sorted = sortRows(items, routeParam(query.sort), routeParam(query.order), {
        action: (item) => item.action,
        created_at: (item) => item.createdAt,
        result: (item) => item.result,
      });
      return resultSuccess(pageRows(sorted, page, pageSize));
    },
  },
  {
    url: '/platform/login-logs',
    method: 'get',
    response: ({ query }) => {
      const page = pageValue(query.page, 1);
      const pageSize = pageValue(query.page_size, 10);
      const keyword = routeParam(query.q)?.trim().toLowerCase();
      const result = routeParam(query.result);
      const from = routeParam(query.from);
      const to = routeParam(query.to);
      const items = loginLogs.filter(
        (item) =>
          (!keyword ||
            `${item.identifier} ${item.requestIp}`.toLowerCase().includes(keyword)) &&
          (!result || item.result === result) &&
          (!from || item.createdAt >= from) &&
          (!to || item.createdAt <= to),
      );
      const sorted = sortRows(items, routeParam(query.sort), routeParam(query.order), {
        created_at: (item) => item.createdAt,
        identifier: (item) => item.identifier,
        result: (item) => item.result,
      });
      return resultSuccess(pageRows(sorted, page, pageSize));
    },
  },
]);
